export enum Network {
  MAIN = 'f',
  TEST = 't',
}
